import FKApi from "@/api/api";
import { AddedPhoto, PortalNoteMedia } from "@/views/notes/model";

export type SilentboxGalleryItem = {
    src: string;
    photo: PortalNoteMedia;
    loading: boolean;
};

export function buildSilentboxGallery(photos: PortalNoteMedia[]): SilentboxGalleryItem[] {
    return photos.map((photo) => ({
        src: "",
        photo,
        loading: true,
    }));
}

export function loadSilentboxGallerySources(
    api: FKApi,
    gallery: SilentboxGalleryItem[],
    setItem: (index: number, item: SilentboxGalleryItem) => void
): void {
    gallery.forEach((entry, index) => {
        api.loadMedia(entry.photo.url).then((src) => {
            setItem(index, { src, photo: entry.photo, loading: false });
        });
    });
}

export function togglePageScrollOnGallery(): void {
    document.body.classList.toggle("disable-scrolling");
}

export async function uploadAddedPhotos(
    stationId: number,
    pending: AddedPhoto[],
    upload: (stationId: number, key: string, file: File) => Promise<PortalNoteMedia>
): Promise<PortalNoteMedia[]> {
    const uploaded: PortalNoteMedia[] = [];
    for (const photo of pending) {
        uploaded.push(await upload(stationId, photo.key, photo.file));
    }
    return uploaded;
}
